import { DetailsSharedActionPage } from './model';

export const enum DetailsSharedActionTypes {
  CHANGE_ACTION_PAGE = '@@details/CHANGE_ACTION_PAGE',
  RESET_SELECTED_PAGE = '@@details/CLEAR_SELECTED_CASE_AND_PAGE',
  CHANGE_ACTION_PAGE_SUCCESS = '@@details/CHANGE_ACTION_PAGE_SUCCESS'
}

export interface DetailsSharedState {
  readonly pages: DetailsSharedActionPage[];
  readonly currentPage: DetailsSharedActionPage;
  readonly previousPage: DetailsSharedActionPage;
}
